const validate = (values, event) => {
    /*
     * get subset of for a specific target element from an array
     * This is used from the blur event to only validate specific fields
     */
    const getSubset = event => {
        const errorSubset = {};
        const target = event.target.name;
        if (errors[target]) errorSubset[target] = errors[target];

        return errorSubset;
    };
    let errors = {};
    // required

    if (!values.newfirstname) {
        errors.newfirstname = "First Name is required";
    }

    if (!/^[a-zA-Z ']{1,50}$/.test(values.newfirstname)) {
        errors.newfirstname = "First name is invalid";
    }

    if (!values.newlastname) {
        errors.newlastname = "Last name is required";
    }

    if (!/^[a-zA-Z ']{1,50}$/.test(values.newlastname)) {
        errors.newlastname = "Last name is invalid";
    }

    if (!values.newemail) {
        errors.newemail = "Email address is required";
    }
    
    if (!/^(?=(.{1,64}@.{1,255}))([!#$%&'*+\-\/=?\^_`\{|}~a-zA-Z0-9}]{1,64}(\.[!#$%&'*+-\/=?^_`{|}~a-zA-Z0-9]{0,}){0,})@(([(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}])|([a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{2,63}){1,})$/.test(values.newemail) || values.newemail.split("@").length > 2) {
        errors.newemail = "Email address is invalid";
    }

    if (!values.newphonenumber) {
        errors.newphonenumber = "Phone number is required";
    }


    if (!/^[+\d\s]{5,24}$/.test(values.newphonenumber)) {
        errors.newphonenumber = "Please enter a valid phone number (5-24 digits)";
    }

    // only validate these fields if the international Value has been set.
    if (values.newinternationalSet) {
        if (!values.newaddresslineone) {
            errors.newaddresslineone = "Address line one is required";
        }

        if (!values.newaddresslinetwo) {
            errors.newaddresslinetwo = "Address line two is required";
        }

        if (!values.newpostcode) {
            errors.newpostcode = "Post code is required";
        }

        if (!values.newcountry) {
            errors.newcountry = "Country is required";
        }
    } else {
        if (values.manualEntryNew) {
            if (!values.newnationaladdresslineone) {
                errors.newnationaladdresslineone = "Address line one is required";
            }

            if (!values.newnationaladdresslinetwo) {
                errors.newnationaladdresslinetwo = "Address line two is required";
            }

            if (!values.newnationalpostcode) {
                errors.newnationalpostcode = "Eircode is required";
            }

            if (!values.newnationalcounty) {
                errors.newnationalcounty = "County is required";
            }
        } else if (!values.newaddress) {
            errors.newaddress = "Please supply an address";
        }
    }

    if (event) {
        errors = getSubset(event);
    }

    return errors;
};

export default validate;
